<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>search</md-icon>
              검색 조건
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>대상학기</th>
                <td>
                  <select v-model="searchQuery.semesterCd" name="semesterCd">
                    <option value="">선택</option>
                    <option v-for="item in semesterCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <th class="letter-dense">장학대상자 학번</th>
                <td>
                  <input type="text" v-model="searchQuery.hakbun" name="hakbun" v-on:keyup.enter="searchQuery">
                </td>
              </tr>
              <tr>
                <th class="letter-dense">장학대상자 성명</th>
                <td>
                  <input type="text" v-model="searchQuery.nm" name="nm" v-on:keyup.enter="searchQuery">
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-info md-sm full-size-button" @click="sendQuery">
              <md-icon>check</md-icon>
              검 색
            </md-button>
          </md-card-actions>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              교우회(장학) 일괄등록
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex mb10">
                <input type="file" class="hidden-input-file" id="excelFileInput" accept=".xlsx">
                <input type="text" v-model="excelFileName" disabled>
                <button @click="onClickSearchExcel">
                  <md-icon>search</md-icon>
                  엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button"
                         @click="uploadExcelFile()"
                         :disabled="!excelFile"
              >
                <md-icon>publish</md-icon>
                엑셀 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              검색 결과
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <div>
                <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>

            <grid ref="HomeReList"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @response="response"
            ></grid>

          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="pagination"></div>
            <div>
              <md-button class="md-default md-sm" @click="deleteSchaHomeRe">
                <md-icon>clear</md-icon>
                삭 제
              </md-button>
            </div>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>

import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import parser from "@/kuaa/kuaa-parser";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  components: {
    grid: Grid
  },

  created() {
    this.getSemesterCdList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data() {
    return {
      isShowUserModal: true,

      searchQuery : {
        semesterCd : null,
        hakbun : '',
        nm : ''
      },

      semesterCdList : [],

      excelFile : null,
      excelFileName : '',

      gridProps: {},
      pagination: {
        perPage: 500,
        page: 1,
        perPageOptions: [800, 500, 200, 100, 50, 20],
        total: 0
      }
    }
  },

  methods: {
    getSemesterCdList (){
      kuaaFnc.fncSemesterCodes(null,res => {
        this.semesterCdList = res.data.data.contents;
      });
    },

    sendQuery (){
      this.$refs.HomeReList.invoke("readData", 1, this.searchQuery);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_SCHA_HOME_RE, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.HomeReList;
      this.gridProps['columns']= [
          {header: '대상학기', name: 'semesterCdNm', align : 'center', sortable: true},
          {header: '학번', name: 'hakbun', align : 'center', sortable: true},
          {header: '성명', name: 'nm', align : 'center', sortable: true},
          {header: '캠퍼스', name: 'collegeLCdNm', align : 'center', sortable: true},
          {header: '대학', name: 'collegeMCdNm', align : 'center', sortable: true},
          {header: '학과/학부', name: 'collegeSCdNm', align : 'center', sortable: true},
          {header: '학년', name: 'collegeSemesterCdNm', align : 'center', sortable: true},
          {header: '장학회지급금액', name: 'amountScha', align : 'center', formatter(value) {return formatter.getCurrency(value.value);}, sortable: true},
          {header: '등록금', name: 'amountUnivTuition', align : 'center', formatter(value) {return formatter.getCurrency(value.value);}, sortable: true},
          {header: '생활비', name: 'amountUnivLiving', align : 'center', formatter(value) {return formatter.getCurrency(value.value);}, sortable: true},
          {header: '지급총계', name: 'amountUnivTotal', align : 'center', formatter(value) {return formatter.getCurrency(value.value);}, sortable: true},
          {header: '연락처1', name: 'phone1', align : 'center', sortable: true},
          {header: '연락처2', name: 'phone2', align : 'center', sortable: true},
          {header: '이메일', name: 'eMail', align : 'center', sortable: true},
          {header: '비고', name: 'etc', align : 'center', sortable: true},
          {header: '소득분위', name: 'incomeQuintile', align : 'center', sortable: true},
          {header: '취득학점', name: 'complateHakjum', align : 'center', sortable: true},
          {header: '평균평점', name: 'avgHakjum', align : 'center', sortable: true}
        ];
      //this.gridSProps['options'].bodyHeight = 300;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.HomeReList, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.HomeReList.invoke("refreshLayout");
    },

    onClickSearchExcel() {
      let input = document.getElementById("excelFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    uploadExcelFile() {
      let xls = this.excelFile;
      parser.parseXlsHomeReBundleData(xls, (res)=>{
        this.saveHomeRe(res)
      });
    },

    saveHomeRe(params){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "저장 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.SAVE_SCHA_HOME_RE_LIST,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `저장 되었습니다.`;
                Swal.fire(modalOptions);
                this.sendQuery();
              } else {
                modalOptions.html = `저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },
    deleteSchaHomeRe(){
      let rows = this.$refs.HomeReList.invoke('getCheckedRows');

      if(!rows.length){
        Swal.fire(kuaaFnc.getSwalModaloptions({'html':'대상을 선택 해 주세요'}));
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "삭제 하시겠습니까?",
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_SCHA_HOME_RE,
            rows,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.$refs.HomeReList.invoke("readData", 1, this.searchQuery);
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    }
  }
}
</script>

<style>

</style>